import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, DateTimeFormat, Spinner, Text, TextArea, useLocalizeMessage, useToastNotification, } from 'libs.nucleus';
import { useDcrApiContext } from '../../contexts';
import { useCreateDcrComment, useDcrComments } from '../../hooks';
export const DcrComments = ({ dcrId, canComment = true }) => {
    const translate = useLocalizeMessage();
    const { addNotification } = useToastNotification();
    const apiContext = useDcrApiContext();
    const [body, setBody] = useState('');
    const { data: comments = [], isLoading } = useDcrComments(apiContext, dcrId);
    const createComment = useCreateDcrComment(apiContext);
    const handleSubmit = async () => {
        try {
            await createComment.mutateAsync({ dcrId, body: body.trim() });
            setBody('');
        }
        catch (error) {
            addNotification({
                title: translate('Could not add the comment'),
                subtitle: error?.response?.data?.reason,
                type: 'error',
            });
        }
    };
    if (isLoading) {
        return _jsx(Spinner, { size: 'sm' });
    }
    return (_jsxs("div", { className: 'flex flex-col gap-6 py-6', children: [canComment ? (_jsxs("div", { className: 'flex flex-col items-end gap-2', children: [_jsx(TextArea, { id: 'dcr-comment-body', label: translate('Add a comment'), value: body, onChange: (event) => setBody(event.target.value), width: 'full', resize: 'none', autogrow: true }), _jsx(Button, { label: translate('Comment'), onClick: handleSubmit, disabled: !body.trim() || createComment.isPending })] })) : null, comments.length === 0 ? (_jsx(Text, { size: 'sm', className: 'text-neutral-500', children: translate('No comments yet') })) : (_jsx("ul", { className: 'flex flex-col gap-4', children: comments.map((comment) => (_jsxs("li", { className: 'flex flex-col gap-1 border-b border-neutral-200 pb-4 last:border-b-0', children: [_jsxs("div", { className: 'flex items-center gap-2', children: [_jsx(Text, { size: 'sm', className: 'font-medium', children: comment.dcr_intake__creator_name || translate('Medable') }), _jsx(Text, { size: 'xs', className: 'text-neutral-500', children: _jsx(DateTimeFormat, { date: comment.dcr_intake__created_date }) })] }), _jsx(Text, { size: 'sm', className: 'whitespace-pre-wrap text-neutral-700', children: comment.dcr_intake__comment_body })] }, comment._id))) }))] }));
};
